import { LoquixCorrectionInput } from './loquix-correction-input.js';

if (!customElements.get('loquix-correction-input')) {
  customElements.define('loquix-correction-input', LoquixCorrectionInput);
}
